import configuration from "./Configuration"
import GeneralIngoinInvoiceDisplay from "@/modules/generalIngoingInvoice/models/GeneralIngoinInvoiceDisplay"
import TransactionItem from "@/modules/transactions/models/TransactionItem";
import VueRouter from "vue-router";

export interface Links {
    router?: VueRouter;
    partnerProfile(invoice: GeneralIngoinInvoiceDisplay): void;
    partnerProfileFromTransaction(invoice: TransactionItem): void;
}


const links: Links = {
    partnerProfile(invoice: GeneralIngoinInvoiceDisplay) {
        links.router?.push(`/partners/${invoice.incomingInvoice.partner}`)
    },
    partnerProfileFromTransaction(invoice: TransactionItem){
        links.router?.push(`/partners/${invoice.partner}`)
    }

}

const operelLinks: Links = {
    partnerProfile(invoice: GeneralIngoinInvoiceDisplay) {
        window.location.href = `#crm/accounts/${invoice.partnerCID}`
    },
    partnerProfileFromTransaction(transaction: TransactionItem){
        // window.location.href = `#crm/accounts/${transaction.partnerCID}`
        console.log("not implemented")
    }
}

export default {
    activate: configuration.operel
        ? operelLinks
        : links
}

